import React, {useState, useEffect, useMemo, memo} from 'react';
import {
  View,
  Text,
  StyleSheet,
  Button,
  useWindowDimensions,
} from 'react-native';
import {useSelector} from 'react-redux';
import {getCleanUrl} from '../../utils/Helper';
import {ImageComp} from '../../components/Image/Image';
import {useCssStyle} from '../../customHook/getCssStyle';
import {useIsFocused, useNavigationState} from '@react-navigation/native';
import RenderHTML from 'react-native-render-html';

const PromoWidget = () => {
  const currentLayout = useSelector(
    state => state.deviceConfigSlice.currentLayout,
  );
  const isFocused = useIsFocused();
  const getStyles = useCssStyle();
  const {width} = useWindowDimensions();
  const tabKey = useNavigationState(state => state.routes[state.index].name);

  // Memoize bigWidgets to avoid unnecessary recomputations
  const bigWidgets = useMemo(
    () => currentLayout?.bigWidgets || [],
    [currentLayout],
  );

  const widgets = useMemo(
    () => bigWidgets.find(widget => widget.uniqueKey == tabKey)?.widgets,
    [bigWidgets, tabKey],
  );
  const [currentWidget, setCurrentWidget] = useState(null);

  useEffect(() => {
    if (!widgets?.length || !isFocused) {
      // setCurrentWidget(null);
      return;
    }

    if (widgets.length == 1) {
      setCurrentWidget(widgets[0]);
    } else {
      let currentIndex = 0,
        length = widgets.length;

      const cycleWidgets = () => {
        const duration = widgets[currentIndex].totalDuration;
        setTimeout(() => {
          currentIndex = (currentIndex + 1) % length;
          setCurrentWidget(widgets[currentIndex]);
          cycleWidgets();
        }, duration);
      };

      cycleWidgets();
      return () => clearTimeout();
    }
  }, [widgets, isFocused]);

  const customWidgetTitleStyle = getStyles([
    'promoWidgetHeaderTitle',
    `promoWidgetHeaderTitle_${currentWidget?.widgetMetaHtmlId}`,
    `promoWidgetHeaderTitle_${currentWidget?.id}`,
  ]);

  const customWidgetSubTitleStyle = getStyles([
    'promoWidgetHeaderSubtitle',
    `promoWidgetHeaderSubtitle_${currentWidget?.widgetMetaHtmlId}`,
    `promoWidgetHeaderSubtitle_${currentWidget?.id}`,
    // { paddingTop: 12 }
  ]);

  return (
    <View id="promoWidgetContainer" style={getStyles(['promoWidgetContainer'])}>
      {currentWidget && (
        <>
          <View
            style={getStyles([
              'promoWidgetImageStyle',
              `promoWidgetImageStyle_${currentWidget.widgetMetaHtmlId}`,
              `promoWidgetImageStyle_${currentWidget.id}`,
            ])}
            id={`promoWidgetImageStyle promoWidgetImageStyle_${currentWidget.widgetMetaHtmlId}`}>
            <ImageComp
              key={getCleanUrl(currentWidget?.btnImageUrl)}
              source={getCleanUrl(currentWidget?.btnImageUrl)}
              style={getStyles(['promoWidgetImage', `promoWidgetImage_${currentWidget.widgetMetaHtmlId}`])}
              id={`promoWidgetImage promoWidgetImage_${currentWidget.widgetMetaHtmlId}`}
            />
          </View>
          {currentWidget.widgetTitle && (
            <RenderHTML
              contentWidth={width}
              baseStyle={customWidgetTitleStyle}
              source={{html: currentWidget.widgetTitle}}
              systemFonts={[customWidgetTitleStyle.fontFamily]}
              id={`promoWidgetHeaderTitle promoWidgetHeaderTitle_${currentWidget.widgetMetaHtmlId}`}
            />
          )}
          {currentWidget.widgetDesc && (
            <RenderHTML
              contentWidth={width}
              baseStyle={customWidgetSubTitleStyle}
              source={{html: currentWidget.widgetDesc}}
              systemFonts={[customWidgetSubTitleStyle.fontFamily]}
              id={`promoWidgetHeaderSubtitle promoWidgetHeaderSubtitle_${currentWidget.widgetMetaHtmlId}`}
            />
          )}
        </>
      )}
    </View>
  );
};

export default memo(PromoWidget);
